export default {
  //店铺权限分页
  userDataPermissionSearch: {
    url: '/ec-pc-api/short/video/userDataPermission/search',
    type: 'post'
  },
  //店铺权限新增-编辑
  userDataPermissioneEditUserData: {
    url: '/ec-pc-api/short/video/userDataPermission/editUserData',
    type: 'post'
  },
  //店铺权限删除
  userDataPermissionDeleteUserData: {
    url: '/ec-pc-api/short/video/userDataPermission/deleteUserData',
    type: 'get'
  },
  //查询下载公告
  BulletinSeach: {
    url: '/ec-pc-api/short/video/bulletin',
    type: 'get'
  },
  //编辑下载公告
  bulletinUpdate: {
    url: '/ec-pc-api/short/video/bulletin/update',
    type: 'post'
  },
  //树形列表
  treeMenus: {
    url: '/ec-pc-api/short/video/folder/treeMenus',
    type: 'post'
  },
  //新增文件夹
  addFolder: {
    url: '/ec-pc-api/short/video/folder/addFolder',
    type: 'post'
  },
  //移动-拖拽报表
  moveFile: {
    url: '/ec-pc-api/short/video/folder/moveFile',
    type: 'post'
  },
  //更新-删除-移动文件夹
  updateFolder: {
    url: '/ec-pc-api/short/video/folder/updateFolder',
    type: 'post'
  },
  //文件搜索
  videoFiles: {
    url: '/ec-pc-api/short/video/files',
    type: 'post'
  },
  //文件删除
  videoFilesDel: {
    url: '/ec-file-api/short/video/files/del',
    type: 'get'
  },
  //文件批量删除
  videoFilesDelBatch: {
    url: '/ec-file-api/short/video/files/batch/del',
    type: 'post'
  },
  //文件上传
  videoUpload: {
    url: '/ec-file-api/short/video/upload',
    type: 'post'
  },
  //按型号、品类、视频类型查询文件列表
  videoTypeFiles: {
    url: '/ec-pc-api/short/video/type/files',
    type: 'get'
  },
  //短视频总览信息分页
  videoOverviews: {
    url: '/ec-pc-api/short/video/overviews',
    type: 'post'
  },
  //办公平台文件上传
  uploadFile: {
    url: '/qu-file-upload-api/upload/app/uploadFile',
    type: 'post'
  },
  //下载记录分页
  downloadLogs: {
    url: '/ec-pc-api/short/video/download/logs',
    type: 'post'
  },
  //获取用户店铺权限列表
  videoUserStores: {
    url: '/ec-pc-api/short/video/user/stores',
    type: 'get'
  },
  //下载文件接口
  videoDownload: {
    url: '/ec-pc-api/short/video/download',
    type: 'post'
  },
  //查询条件下拉列表
  videoCriterias: {
    url: '/ec-pc-api/short/video/criterias',
    type: 'get'
  },
  //店铺权限-店铺下拉列表[查询条件]
  userDataPermissionStores: {
    url: '/ec-pc-api/short/video/userDataPermission/stores',
    type: 'get'
  },
  //下载记录分页-店铺下拉
  logsOptions: {
    url: '/ec-pc-api/short/video/download/logs/options',
    type: 'post'
  },
  //下载文件接口v2
  videoDownloadv2: {
    url: '/ec-file-api/short/video/download/v2',
    type: 'post'
  },
  //下载文件接口v2[不记录下载历史]
  downloadFiles: {
    url: '/ec-file-api/short/video/download/files',
    type: 'post'
  },
  //下载文件接口v2[不记录下载历史]
  updateFileName: {
    url: '/ec-pc-api/short/video/files/updateFileName',
    type: 'post'
  },
  //短视频总览信息-批量查询
  videoBatchQuery: {
    url: '/ec-pc-api/short/video/batchQuery',
    type: 'post'
  },
  //短视频文件上传
  uploadFiles: {
    url: '/ec-file-api/short/video/uploadFiles',
    type: 'post'
  },
  //产品下拉查询
  videoProductList: {
    url: '/ec-pc-api/short/video/productList',
    type: 'get'
  },
}
